(() => {
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const words = value => normalize(value).match(/[a-z0-9]+/g) || [];
  const compact = value => words(value).join('');
  function closeWord(a, b) {
    if (a === b || (a.length >= 3 && b.startsWith(a))) return true;
    if (a.length < 5 || /\d/.test(a + b) || Math.abs(a.length - b.length) > 1) return false;
    let i = 0, j = 0, edits = 0;
    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++edits > 1) return false;
      if (a.length === b.length && a[i] === b[j + 1] && a[i + 1] === b[j]) { i += 2; j += 2; }
      else if (a.length > b.length) i++;
      else if (a.length < b.length) j++;
      else { i++; j++; }
    }
    return edits + a.length - i + b.length - j <= 1;
  }
  function analyze(query) {
    const raw = String(query || '').trim().replace(/^sku\s*:\s*/i, '');
    const advanced = /[:*()"]|\b(?:OR|NOT)\b/.test(raw);
    const first = raw.split(/\s+/)[0] || '';
    const prefix = normalize(first).match(/^([a-z]{1,12}\d+)/)?.[1];
    const size = normalize(raw).match(/(?<!\d)(\d{2}(?:\.\d+)?)\s*\/\s*(\d{1,2}(?:\.\d+)?)\b/);
    const sku = !advanced && !!prefix && compact(first).length >= 6 && (!!size || !/\s/.test(raw));
    const tokens = words(size ? raw.replace(size[0], '') : raw), identifiers = [], remaining = [], normalizedTokens = [];
    for (let i = 0; i < tokens.length; i++) {
      const current = tokens[i], next = tokens[i + 1], third = tokens[i + 2];
      let identifier;
      if (/^[a-z]{1,6}$/.test(current) && /^[a-z]$/.test(next || '') && /^\d{1,2}$/.test(third || '')) {
        identifier = current + next + third; i += 2;
      } else if (/^[a-z]{1,6}$/.test(current) && /^(?:[a-z]{0,2})\d{1,2}$/.test(next || '')) {
        identifier = current + next; i++;
      } else if (/^[a-z]+\d[a-z0-9]*$/.test(current)) identifier = current;
      if (identifier) { identifiers.push(identifier); normalizedTokens.push(identifier); }
      else { remaining.push(current); normalizedTokens.push(current); }
    }
    return {
      raw, advanced, sku, fullSku: sku && !!size, prefix,
      size: size ? size[1] + '/' + size[2] : null,
      identifiers,
      remaining: remaining.filter(word => !['a', 'an', 'the', 'for', 'of', 'with', 'and'].includes(word)),
      searchQuery: advanced ? raw : sku ? '(variants.sku:' + prefix + '* OR title:' + compact(first) + ' OR title:"' + normalize(first).replace(/([a-z])([0-9])|([0-9])([a-z])/g, '$1$3 $2$4') + '")' : identifiers.length ? normalizedTokens.join(' ') : raw
    };
  }
  function titleIdentifiers(title) {
    const tokens = words(title), result = new Set();
    tokens.forEach((word, i) => {
      result.add(word);
      if (tokens[i + 1]) result.add(word + tokens[i + 1]);
      if (tokens[i + 2]) result.add(word + tokens[i + 1] + tokens[i + 2]);
    });
    return result;
  }
  function assess(record, plan, stockOnly = false) {
    const variants = record.variants || [];
    const exact = plan.sku && variants.some(variant => compact(variant.sku) === compact(plan.raw));
    if (stockOnly && !record.available) return { match: false, exactSku: exact };
    if (plan.advanced || !plan.raw) return { match: true, rank: 0 };
    const eligible = variants.filter(variant => !stockOnly || variant.available);
    if (plan.sku) {
      const needle = compact(plan.raw);
      const matches = eligible.filter(variant => plan.fullSku ? compact(variant.sku) === needle : compact(variant.sku).startsWith(needle));
      const variant = matches.find(item => item.available) || matches[0];
      if (variant) return { match: true, rank: plan.fullSku ? 100 : 80, variant, exactSku: exact };
      if (exact) return { match: false, exactSku: true };
    }
    const titleCodes = titleIdentifiers(record.title);
    if (!plan.identifiers.every(code => titleCodes.has(code) || (code.length >= 6 && eligible.some(variant => compact(variant.sku).startsWith(code))))) return { match: false };
    const searchable = words(record.search || record.title);
    if (!plan.remaining.every(word => searchable.some(other => closeWord(word, other)))) return { match: false };
    let variant;
    if (plan.size) {
      const sizeKey = plan.size.replace(/\s/g, '');
      variant = eligible.find(item => normalize(item.title + ' ' + item.sku).replace(/\s/g, '').includes(sizeKey));
      if (!variant) return { match: false };
    }
    return { match: true, rank: plan.identifiers.length ? 60 : 10, variant };
  }
  function record(card) {
    let variants = [];
    try { variants = JSON.parse(card.dataset.premierVariants || '[]'); } catch (_) { return null; }
    return { title: card.dataset.premierTitle, search: card.dataset.premierSearch, available: card.dataset.premierAvailable === 'true', variants };
  }
  function prepareCard(card, plan, stockOnly = false) {
    const data = record(card);
    if (!data) return { match: false };
    const result = assess(data, plan, stockOnly);
    card.dataset.premierExactSku = String(!!result.exactSku);
    if (result.match && result.variant) {
      card.dataset.premierMatchedVariant = result.variant.id;
      card.querySelectorAll('a[href*="/products/"]').forEach(link => {
        const url = new URL(link.getAttribute('href'), location.origin);
        url.searchParams.set('variant', result.variant.id);
        link.setAttribute('href', url.pathname + url.search + url.hash);
      });
    }
    return result;
  }
  window.PremierSearch = { analyze, assess, prepareCard };
})();
